export default __webpack_public_path__ + "static/media/IMG_0792.01a475df.jpg";